import { render, staticRenderFns } from "./selfpaywx.vue?vue&type=template&id=94efcc3e&scoped=true"
import script from "./selfpaywx.vue?vue&type=script&lang=js"
export * from "./selfpaywx.vue?vue&type=script&lang=js"
import style0 from "./selfpaywx.vue?vue&type=style&index=0&id=94efcc3e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94efcc3e",
  null
  
)

export default component.exports